import React from 'react';
import { PlusSquareTwoTone } from '@ant-design/icons';
import { useTranslation } from 'react-i18next';

function CodeLine(props) {
  const { t } = useTranslation();
  const hasThread = !!props.hasThread;
  return (
    <tr className="line">
      <td
        className={`line-number${hasThread ? ' has-thread' : ''}`}
        onClick={() => props.toggleLineCommentBoxVisibility(props.index + 1)}
        title={hasThread ? t('view thread') : t('add comment')}
      >
        {props.index + 1}
      </td>
      <td id={'plus' + props.index} className="plus-square-line">
        <PlusSquareTwoTone
          className="plus-square"
          twoToneColor="var(--accent)"
          onClick={() => props.toggleLineCommentBoxVisibility(props.index + 1)}
        />
      </td>
      <td
        className="code-row"
        dangerouslySetInnerHTML={{ __html: props.code }}
      />
    </tr>
  );
}

export default CodeLine;
